import styled from "styled-components";
import { boolean } from "yup";

// Центральное модальное окно
export const CenteredModal = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    width: 1060px;
    max-width: 90%;
    max-height: 90%;
    padding: 20px;
    z-index: 1550;
`;

export const WrapGroups = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
`

export const StyledGroup = styled.div`
    display: flex;
    flex-direction: column;
    width: 500px;

`

// Задний фон (оверлей)
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1040;
`;

// Кнопки модального окна
export const ModalButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
`;

// Заголовок модального окна
export const ModalHeader = styled.h2`
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
`;

// Поля формы
export const FormField = styled.div`
    margin-bottom: 15px;

    label {
        display: block;
        font-weight: 500;
        margin-bottom: 5px;
    }

    input,
    textarea {
        width: 100%;
        height: 100%;
        padding: 10px;
        font-size: 14px;
        border: 1px solid #ccc;
        border-radius: 4px;
        max-width: 100%;
        min-width: 100%;
    }
`;

export const StyledTextArea = styled.div<{
    $hasError: boolean    
}>`
    margin-bottom: 15px;
    height: 100%;
    padding-bottom: 30px;
    label {
        display: block;
        font-weight: 500;
        margin-bottom: 5px;
    }
    textarea {
        flex: 1; /* Растянуть textarea */
        width: 100%;
        height: 210px;
        padding: 10px;
        font-size: 14px;
        border: 1px solid ${(props) => (props.$hasError ? "red" : "#ccc")};
        border-radius: 4px;
        background-color: ${(props) => (props.$hasError ? "#ffe6e6" : "#fff")};
    }

    .error {
        color: red;
        font-size: 12px;
        margin-top: 5px;
    }
`;

export const MediaWrap = styled.div`
`
export const MediaButton = styled.div`
`
export const MediaPreview = styled.div`
`
export const InputField = styled.div<{
    $hasError: boolean    
}>`
    margin-bottom: 15px;
    
    label {
        display: block;
        font-weight: 500;
        margin-bottom: 5px;
    }

    input,
    textarea {
        width: 100%;
        padding: 10px;
        font-size: 14px;
        border: 1px solid ${(props) => (props.$hasError ? "red" : "#ccc")};
        border-radius: 4px;
        background-color: ${(props) => (props.$hasError ? "#ffe6e6" : "#fff")};
    }

    .error {
        color: red;
        font-size: 12px;
        margin-top: 5px;
    }
`;

export const CheckboxField = styled.div`
    margin-bottom: 15px;

    display: flex;
    align-items: center;

    label {
        margin-left: 10px;
        font-weight: 500;
    }

    input {
        transform: scale(1.2); /* Увеличение размера чекбокса */
    }
`;